'use client';

import { useRef } from 'react';

/** Assign DOM node to local and optional external ref. */
export function assignInputRef(localRef, externalRef, node) {
  localRef.current = node;
  if (!externalRef) return;
  if (typeof externalRef === 'function') externalRef(node);
  else externalRef.current = node;
}

/**
 * After confirming an address suggestion, focus the next field in the chain.
 * Retries while the next input is still disabled (parent state updating).
 */
export function advanceAddressFocus({ nextInputRef, onEnterPress } = {}) {
  if (onEnterPress) {
    setTimeout(() => onEnterPress(), 0);
    return;
  }
  if (!nextInputRef) return;

  let attempts = 0;
  const maxAttempts = 12;

  const tryFocus = () => {
    const next = nextInputRef.current;
    if (next && !next.disabled && typeof next.focus === 'function') {
      next.focus();
      if (typeof next.select === 'function') next.select();
      return;
    }
    if (attempts < maxAttempts) {
      attempts += 1;
      setTimeout(tryFocus, 50);
    }
  };

  setTimeout(tryFocus, 0);
}

/** Ref chain props for city → street → house → apartment address search inputs. */
export function useAddressInputChain() {
  const streetInputRef = useRef(null);
  const buildingInputRef = useRef(null);
  const roomInputRef = useRef(null);

  return {
    city: { nextInputRef: streetInputRef },
    street: { inputRef: streetInputRef, nextInputRef: buildingInputRef },
    building: { inputRef: buildingInputRef, nextInputRef: roomInputRef },
    room: { inputRef: roomInputRef },
  };
}
